import { gql } from '@apollo/client';

const UPDATE_LICENSE_INFORMATION = gql`
  mutation UpdateLicenseInformation($data: LicenseInformationInput!) {
    updateLicenseInformation(data: $data)
  }
`;

export default UPDATE_LICENSE_INFORMATION;
